import { InventoryActivitySearchCriteria } from "./InventoryActivitySearchCriteria";

export interface AdminInventoryActivitySearchCriteria extends InventoryActivitySearchCriteria{
  buyerId?: string,
  supplierId?: string,
}

/** Keys that make the report search all dates while filled (see `withDateRangeBypass`). */
export const ADMIN_INTERCHANGES_DATE_BYPASS_KEYS: readonly (keyof AdminInventoryActivitySearchCriteria)[] = ['bookingNumber'];
